import apiClient from 'BrokerTsLib/src/Utils/apiClient'
import { useMutation } from '@tanstack/react-query'

import { Apis } from '@/appSettings'

import { useUrl } from '.'

export const useCreateInsuranceParamsFromDraft = () => {
  const url = useUrl(Apis.insuranceDraft)

  return useMutation({ mutationFn: (draft?: string) =>
    apiClient.post<number>(`${url}/CreateInsuranceParamsFromDraft`, undefined, { params: { draft } }) })
}